import React, { useRef, useEffect, useState } from 'react';

import PlayButton from "./components/PlayButton";
import Legend from "./components/Legend"
import SearchBar from "./components/SearchBar"
import "./components/SplashScreen.css"
import Dropdown from 'react-bootstrap/Dropdown';
import SplitButton from "react-bootstrap/SplitButton";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import mapboxgl from 'mapbox-gl';
import instance from './components/AxiosInstance'
import { useLocation } from "react-router-dom";

// used for accessing styles
mapboxgl.accessToken = 'pk.eyJ1IjoiYWRsdWtlNjEiLCJhIjoiY2tjbGkwdnZ1MDB2ZDJzbXc1Z3U1bnhkZiJ9.X93y_D0mouTRkAErRcYR-Q';

export default function App() {
    const us_center = [-95.7129, 37.0902]  // center of LA. Should be dynamically set based on site selected
    const map_style = 'mapbox://styles/adluke61/clq07q3fb013901p7g7839nd1' // points to the mapbox style
    const mapContainer = useRef(null);
    const url_location = useLocation()
    const [map, setMap] = useState(null);
    const [location, setLocation] = useState(null);
    const [lng, setLng] = useState(us_center[0]);  // initialize using US coords
    const [lat, setLat] = useState(us_center[1]);
    const [zoom, setZoom] = useState(3);
    const [entered, setEntered] = useState(false);
    const [consented, setConsented] = useState(false);
    const [agreed, setAgreed] = useState(false);
    //adam giving base_path + tile_dir in response
    const mapbox_access_token = 'sk.eyJ1IjoiYWRsdWtlNjEiLCJhIjoiY2xxcHJsZDNsM2p4cjJrbW1kdWR6ZmRweSJ9.QY44k8Pa_dAFGkRVXMBRtw'
    const base_url = process.env.REACT_APP_API_ROOT || "https://r902a4mgz7.execute-api.us-east-2.amazonaws.com/dev";
    const [mapData, setMapData] = useState(null);
    const [isLoading, setIsLoading] = useState(true); // true when map data is being loaded; false otherwise
    const additional_map_data = {
        "/splatte_10m": {
            "domain_name": "South Platte",
            "domain_center_lat": 40.016958,
            "domain_center_lng": -105.26119,
            "census_tracts_url": null,
            "census_tracts_layer": null,
            "tile_directory": "https://d1xlle4l6y1lrj.cloudfront.net/splatte/10m/500yr/tiles/",
            "hide_search_bar": true
        },
        "/splatte_3m": {
            "domain_name": "South Platte",
            "domain_center_lat": 40.016958,
            "domain_center_lng": -105.26119,
            "census_tracts_url": null,
            "census_tracts_layer": null,
            "tile_directory": "https://d1xlle4l6y1lrj.cloudfront.net/splatte/3m/500yr/tiles/",
            "hide_search_bar": true
        }
    }


    function onCoverageSelect (x) {
        setEntered(true);
        setLocation(x);
    }

    async function onClickLA() {
        setEntered(true);
    }

    async function get_updated_map() {
        const mapData = await get_map_data();
        update_map(mapData);
    }

    async function get_census_data (coord) {
        const census = await get_point_data(coord);
        console.log(census);
    }



    function update_map(mapData) {
        setLng(mapData.domain_center_lng);
        setLat(mapData.domain_center_lat);
        add_sources(map, mapData);
        map.flyTo({
                    center: [mapData.domain_center_lng, mapData.domain_center_lat],
                    essential: true,
                    zoom: 9
                });
    }


    async function get_map_data() {
          try {
              console.log("path")
              console.log(url_location.pathname)
              if (url_location.pathname == "/" | !(url_location.pathname in additional_map_data)) { // by default, we return the Los Angeles Data
                  const response = await instance.post(base_url + "/get_map_data", {
                      "domain_name": "Los Angeles",
                      "sim_name": "1% Annual Chance Flood Hazard",
                      "client": "public"
                  });
                  setMapData(response.data);
                  console.log(response)
                  return (response.data);
              } else {
                let mapData = additional_map_data[url_location.pathname]
                  setMapData(mapData)
                  return mapData
              }
          } catch (error) {
            console.error('Error sending POST request:', error);
          }
    };

    async function get_point_data(loc) {
          try {
            const response = await instance.post(base_url+ "/get_point_data", {
                    "domain_name": "Los Angeles",
                    "lat": loc.lat,
                    "lng": loc.lng
                });
            //setCensus(response.data.block_analysis);
            return(response.data.block_analysis);
          } catch (error) {
            console.error('Error sending POST request:', error);
          }
    };



    function get_first_symbol_id(layers){
        for (let i = 0; i < layers.length; i++) {
                if (layers[i].id === 'road-label') {
                    return layers[i].id;
                }
            }
    }


    function ConsentForm() {
        const [checked, setChecked] = React.useState(false);

        //toggle checked state T/F when the input box is clicked
        const handleCheckboxChange = (event) => {
            setChecked(!checked);
        };

        //process the submit button click
        const handleSubmit = (event) => {
            if (checked) {
                setConsented(true);
                get_updated_map();
            } else {
                // Optionally, you can display an error message or handle the lack of consent
                console.log('Please agree to terms and conditions');
            }

        };

        return (
        <Form onSubmit={handleSubmit}>
            <Form.Check type="checkbox" onChange={handleCheckboxChange} label="I agree to terms and conditions"/>
            <div className='button-wrapper'>
              <Button type="submit" disabled={!checked}>Submit</Button>
            </div>
        </Form>
      );
}

    function SplashScreen(props) {
        return (
            <div className="splashscreen-opener">
                <h1>Get Prepared for Future Flooding</h1>
                <p>Access cutting-edge flood risk data for properties and census tracts</p>
                <p>Plan and prioritize your infrastructure improvements</p>
                <br/>
                <div className='button-wrapper'>
                    <Button
                        onClick={onClickLA}
                        disabled={props.isLoading}
                        >
                        {props.isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  : 'See a Demonstration of Our Data'
                        }
                    </Button>
                </div>
            </div>
        )

    }

    function ConsentScreen() {
        return (
            <div className="splashscreen-consent">
                <div className="splashscreen-consent-text">
                <h6 className='p-header'>TERMS.</h6>
                    <p>These Terms and Conditions of Use (the “Terms”) govern your use of and access to ZeppelinFloods.com and
                its sub-domains and affiliated sites, as well as Zeppelin Floods LLC’s (“Zeppelin Floods”) pages and
                accounts on Facebook®, Twitter®, LinkedIn®, Google Plus®, YouTube®, and any other social media website
                (collectively the “Sites”), and its Services (as hereinafter defined). Please read both these Terms carefully.
                        You may not use the Sites or the Services until you have read
                the Terms. By using any or all of the Sites or the Services, you accept and agree to be bound by these
                Terms. If you do not want to agree to be bound by these Terms, do not use the Sites or the Services.
                Zeppelin Floods may modify these Terms at any time, and any modifications will be effective immediately
                unless otherwise stated. Your continued use of a Site or the Services following any changes
                means you accept and agree to any changes. As used in these Terms, the terms "you", "your" or
                "user" all refer to both the person using the Sites or the Services in any way, including those
                registered as, for, or on behalf of a corporate entity, such as a company, business, affiliated
                entities, corporation, government agency, or other business entity and its employees, subcontractors,
                affiliates, and all other persons or entities permitted to access and use the Sites or the Services.</p>
                    <br/>
            <h6 className='p-header'>SITE CONTENT.</h6>
            <p>Zeppelin Floods exclusively owns and controls the Sites, which, among other things, provides information
                about products and services and access to a variety of materials and content.
                You agree that use or access to any or all of the Sites or the
                Services does not create any sort of representation or future promise. Zeppelin Floods does not warrant
                or make any representation of accuracy regarding the information or data contained, described in, or
                related to the Services. Zeppelin Floods shall own any feedback, recommendations, or suggestions that
                you may provide to Zeppelin Floods and may use the results of such feedback for any purpose, including
                but not limited to in its marketing and promotional materials. The unauthorized reproduction,
                sublicensing, sharing, use of, or theft of any content, written, photographic, video or otherwise, is
                expressly prohibited. Any use of the Sites or Services in violation of these terms will constitute
                infringement of Zeppelin Floods’ intellectual property rights.</p>
                    <br/>
            <h6 className='p-header'>INTELLECTUAL PROPERTY.</h6>
            <p>Unless explicitly stated otherwise, as between you and Zeppelin Floods, Zeppelin Floods owns and retains
                all right, title, and interest in and to (a) the Services; (b) its Sites; and (c) all associated
                content, materials, graphics, logos, slogans, product and service names, information, and other
                intellectual property. All other names, logos, product and service names, designs and slogans on the
                Sites are the trademarks of their respective owners and should not be used without those respective
                owners’ permission. You are granted a limited, non-exclusive, non-transferable, revocable license to
                access and use the Sites and the Services therein, including the resources available for download or
                streaming strictly in accordance with these Terms and solely for your personal purposes.</p>
                    <br/>
            <h6 className='p-header'>THIRD PARTY RIGHTS.</h6>
            <p>Content and materials posted to the Sites may be the copyrighted content of others (“Third Party
                Content”) that is used by Zeppelin Floods either by permission or under Section 107 of the Copyright Act
                as “fair use” for purposes such as education and research. Users must obtain permission from the owners
                of any Third-Party Content before copying, distributing or otherwise using those materials. Except as
                otherwise expressly permitted under copyright law, no copying, redistribution, retransmission,
                publication, or commercial exploitation of downloaded material will be permitted without the express
                permission of the copyright owner.</p>
                    <br/>
            <p>If you believe that your work has been copied on one or more of the Sites in a way that constitutes
                copyright infringement or otherwise violates your intellectual property rights, please contact us via
                email at the contact information listed below and provide the following: (i) identification of what is
                claimed to have been infringed; (ii) identification of what is claimed to be infringing; (iii) your
                contact information (or the contact information of the person we need to contact about the
                infringement); (iv) a statement that the person submitting the complaint is doing so with a good faith
                belief that use of the material in the manner complained of is not authorized by the owner, its agent,
                or the law; (v) a statement that the information provided is accurate, and under penalty of perjury;
                (vi) a physical or electronic signature of the person submitting the complaint; and (vii) if that person
                is not the owner of the content at issue, a statement that the person submitting the complaint is
                authorized to act on the owner’s behalf.</p>
                    <br/>
            <h6 className='p-header'>LINKING TO OUR SITES.</h6>
            <p>Anyone linking to the Sites must comply with all applicable laws and must not: (i) misrepresent its
                relationship with Zeppelin Floods; (ii) present false or misleading information about Zeppelin Floods;
                or (iii) contain content that is reasonably considered profanity, offensive, defamatory, vulgar, or
                unlawful.</p>
                    <br/>
            <h6 className='p-header'>ADVERTISEMENTS AND LINKS.</h6>
            <p>Zeppelin Floods may at times include advertisements on the Sites. Your correspondence or business
                dealings with, or participation in promotions of, advertisers found on or through the Sites are solely
                between you and such advertiser. Any opinions, advice, statements, services, offers, or other
                information or content expressed or made available by advertisers, including information providers, or
                any other end users are those of the respective author(s) and not our own. You agree that Zeppelin Floods
                shall not be responsible or liable for any loss or damage of any sort incurred as a result of
                any such dealings or as the result of the presence of such advertisers. Any affiliate links on the Sites
                will be clearly marked; however, you may reach out to Zeppelin Floods using the contact information
                listed below with any questions you may have regarding affiliate links.</p>
                    <br/>
            <p>You may find links to other websites on a Site. These links are provided solely as a convenience to you
                and not as an endorsement by Zeppelin Floods of the contents on such third-party sites, and Zeppelin Floods
                expressly disclaims any representations regarding the content or accuracy of materials on such
                third-party websites. You acknowledge and agree that Zeppelin Floods shall not be responsible or liable,
                directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with
                use of or reliance on any such content, goods or products available on or through any such linked site.
                You agree that it is your responsibility to evaluate the accuracy, completeness, or usefulness of any
                information, opinion, advice, etc., or other content available through such third-party sites.</p>
                    <br/>
            <h6 className='p-header'>DISCLAIMER AND LIMITATION OF LIABILITY.</h6>
            <p>THE SITES AND THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT WARRANTY OF ANY
                KIND. ZEPPELIN FLOODS, TOGETHER WITH ITS AFFILIATES, LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
                OFFICERS OR DIRECTORS (THE “RELEASED PARTIES”), SPECIFICALLY DISCLAIM ALL WARRANTIES, EXPRESS OR
                IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                AND NON-INFRINGEMENT AND WARRANTIES THAT MAY ARISE OUT OF COURSE OF DEALING, COURSE OF PERFORMANCE,
                USAGE OR TRADE PRACTICE. THE RELEASED PARTIES DO NOT GUARANTEE THE RELIABILITY, ACCURACY, COMPLETENESS,
                SAFETY, TIMELINESS, LEGALITY, USEFULNESS, ADEQUACY OR SUITABILITY OF ANY OF THE INFORMATION OR CONTENT
                ON THE SITES. ZEPPELIN FLOODS AND THE RELEASED PARTIES DO NOT WARRANT THAT THE SERVICE OR SITES WILL BE
                ERROR FREE, FREE FROM ANY VIRUS, MALWARE, OR HARMFUL CODE, FREE FROM INTERRUPTIONS, WILL NOT INFRINGE
                THE INTELLECTUAL PROPERTY RIGHTS OF ANY THIRD PARTY, OR ACCOMPLISH ANY PARTICULAR RESULT. ACCORDINGLY,
                YOU AGREE TO EXERCISE CAUTION, DISCRETION AND COMMON SENSE WHEN USING THE SITES. THE ENTIRE RISK FOR USE
                OF THE SITE AND/OR SERVICES IS BORNE BY YOU. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO
                EVENT SHALL THE RELEASED PARTIES BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL
                OR PUNITIVE DAMAGES ARISING OUT OF THE USE OF OR INABILITY TO ACCESS THE SITES, INCLUDING, WITHOUT
                LIMITATION, DAMAGES FOR LOSS OF GOODWILL, WORK DISRUPTIONS, COMPUTER FAILURE OR MALFUNCTION, OR ANY AND
                ALL OTHER PERSONAL OR COMMERCIAL DAMAGES OR LOSSES, EVEN IF ADVISED OF THE POSSIBILITY THEREOF, AND
                REGARDLESS OF THE LEGAL OR EQUITABLE THEORY (CONTRACT, TORT, BREACH OF WARRANTY OR OTHERWISE) UPON WHICH
                THE CLAIM IS BASED. THE RELEASED PARTIES ARE NOT RESPONSIBLE FOR ANY LIABILITY ARISING OUT OF THE
                POSTINGS OR ANY MATERIAL LINKED THROUGH THE SITES. YOUR SOLE REMEDY WITH RESPECT TO ANY CLAIM ARISING
                OUT OF YOUR USE OF THE SITES AND SERVICES IS TO CEASE USING THE SITES AND SERVICES. IN NO EVENT SHALL
                ZEPPELIN FLOODS’ TOTAL LIABILITY EXCEED AN AMOUNT EQUAL TO THE LESSOR OF ACTUAL DAMAGES INCURRED OR THE
                FEES PAID BY YOU IN THE TWELVE (12) MONTH PERIOD PROCEEDING THE EVENT GIVING RISE TO SUCH LIABILITY FOR
                THE SERVICES GIVING RISE TO SUCH LIABILITY. </p>
                    <br/>
            <h6 className='p-header'>INDEMNIFICATION.</h6>
            <p>YOU AGREE TO INDEMNIFY, DEFEND, AND HOLD ZEPPELIN FLOODS HARMLESS FROM AND AGAINST ANY DAMAGES, CLAIMS OR
                LOSSES ARISING FROM YOUR: (A) BREACH OF THESE TERMS; (B) INFRINGEMENT OF ANY THIRD-PARTY INTELLECTUAL
                PROPERTY; AND (C) NEGLIGENCE, WILLFUL MISCONDUCT, OR VIOLATION OF LAW. ZEPPELIN FLOODS SHALL NOT BE
                LIABLE FOR ANY SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES, ARISING OUT OF OR
                RELATED TO THIS AGREEMENT, WHETHER OR NOT A PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES,
                AND WHETHER BASED UPON BREACH OF CONTRACT, WARRANTY, OR STATUTORY DUTY, NEGLIGENCE, STRICT LIABILITY OR
                OTHER TORT, PRINCIPLES OF INDEMNITY OR CONTRIBUTION, OR OTHERWISE. YOU AGREE THAT ZEPPELIN FLOODS WILL
                NOT MAKE ANY COURT APPEARANCES ON YOUR BEHALF WITHOUT A SUBPOENA AND IF ZEPPELIN FLOODS IS REQUIRED TO
                MAKE A COURT APPEARANCE DUE TO A SUBPOENA BY YOU, THEN YOU SHALL INDEMNIFY AND REIMBURSE ZEPPELIN FLOODS
                FOR ALL RELATED LOSSES AND EXPENSES. </p>
                    <br/>
            <h6 className='p-header'>CHOICE OF LAW AND VENUE.</h6>
            <p>These Terms are governed by the laws of the State of Illinois without regard to any conflict
                of laws. For any dispute regarding these Terms, the Sites, or the Services, you agree to submit to the
                personal and exclusive jurisdiction and venue of the federal and state courts located in Cook County,
                Illinois.</p>
                    <br/>
            <h6 className='p-header'>MISCELLANEOUS.</h6>
            <p>Should any provision of these Terms be found unenforceable, the remainder of these Terms shall remain in
                full force and effect. These Terms constitute the
                entire agreement between you and Zeppelin Floods and supersedes any oral or written communications
                between us. In the event of conflict between these Terms and any other agreement or understanding
                between the parties, these Terms shall govern.</p>
                    <br/>
            <h6 className='p-header'>YOUR COMMENTS AND CONCERNS.</h6>
            <p>All feedback, comments, requests for technical support and other communications relating to the Sites or
                the Services should be directed to: hello@zeppelinfloods.com </p>
                </div>
                <br/>
                <div className="splashscreen-consent-form">
                    <ConsentForm></ConsentForm>
                </div>
            </div>
        )
    }

    function add_sources(map, mapData) {
        let layers = map.getStyle().layers;
        let firstSymbolId = get_first_symbol_id(layers) // returns the layer number of road network. used
                                                        // so flood layer is on top of roads
        map.addSource("flood-layer", {
            "type": "raster",
            "minzoom": 9,
            "maxzoom": 17,
            "tiles": [`${mapData.tile_directory + "{z}/{x}/{y}.png"}`], //populate this from the data Adam gives
            "scheme": "tms",
            "tileSize": 256,
        }); // adds a data source

        if (mapData.census_tracts_url) {
            map.addSource("census-tracts", {
                type: "vector",
                url: `${mapData.census_tracts_url}` //we are not loading in everything, just pointing in on server, give data to load in all spatial information
            }) //Adam given url here too
        }

        if (mapData.census_tracts_layer) {
            map.addLayer({
                "id": "census-tracts",
                "type": 'fill',
                "source": 'census-tracts',
                "source-layer": `${mapData.census_tracts_layer}`, //given from response
                'paint': {
                    'fill-outline-color': 'rgba(0,0,0,0.1)',
                    'fill-color': 'rgba(0,0,0,0.1)'
                }
            })
            map.addLayer({
                "id": "census-tracts-highlighted",
                "type": 'line',
                "source": 'census-tracts',
                "source-layer": `${mapData.census_tracts_layer}`,
                'paint': {
                    'line-color': '#7F00FF',
                    'line-width': 3
                },
                'filter': ['==', 'FIPS', '']
            })
            // when we mouse over the census-tracts, change mouse to pointer
            map.on('mouseenter', 'census-tracts', () => {
                map.getCanvas().style.cursor = 'pointer'
            })
            // when we leave the fema-later, remove pointer
            map.on('mouseleave', 'census-tracts', () => {
                map.getCanvas().style.cursor = ''
            })
        }
        map.addLayer({
            "id": "flood-layer",
            "type": "raster",
            "source": "flood-layer",
            'layout': {
                'visibility': 'visible'
            },
            "paint": {
                "raster-opacity": 1
            },

        }, firstSymbolId); // adds layer to map

        map.addControl(new mapboxgl.NavigationControl()); // adds the zoom button
    }

    useEffect(() => { // this fires when the component first loads
        if (map) return; // initialize map only once
        //this is like the api
        let newMap = new mapboxgl.Map({
            container: mapContainer.current,
            style: map_style,
            center: [lng, lat],
            zoom: zoom
        });

        newMap.on('load', function(){
            setMap(newMap) // this sets the map variable to not null
            setIsLoading(false)
        })
    });

    return (

            <div id="map-wrapper"  data-testid="wrapper-test">
                <div ref={mapContainer} className="map-container"/>
                {console.log("in component")}
                {(!entered && !consented) && <SplashScreen isLoading={isLoading}></SplashScreen>}
                {(entered && !consented) && <ConsentScreen></ConsentScreen>}
                {(entered && consented && map && mapData && !("hide_search_bar" in mapData)) && <SearchBar map={map} mapboxgl={mapboxgl} accessToken={mapbox_access_token} base_url={base_url} ></SearchBar> }
                {(entered && consented) && <Legend></Legend>}
            </div>

    );

}